import {
	colorsNew,
	errorColor, linkColor,
} from 'root/src/client/web/commonStyles'
import { errorStyle } from 'root/src/shared/constants/styles'

export default {
	ddWrapper: {
	},
	formHeader: {
		display: 'flex',
		color: 'currentColor',
		margin: 0,
		cursor: 'text',
		minWidth: 0,
		boxSizing: 'border-box',
		background: 'none',
		borderRadius: 4,
		overflow: 'hidden',
	},
	formHeaderLocked: {
		cursor: 'not-allowed',
	},
	inputWrapper: {
		position: 'relative',
		height: '100%',
		width: '100%',
		backgroundColor: colorsNew.dark2,
		borderRadius: 3,
		borderBottom: '1px solid transparent',
		transitionDuration: 200,
		'&:hover': {
			borderBottom: `1px solid ${linkColor}`,
		},
		'&:focus': {
			borderBottom: `1px solid ${linkColor}`,
		},
	},
	inputWrapperLocked: {
		'&:hover': {
			borderBottom: '1px solid transparent',
		},
		'&:focus': {
			borderBottom: '1px solid transparent',
		},
	},
	inputWrapperError: {
		borderBottom: `1px solid ${errorColor}`,
		'&:hover': {
			borderBottom: `1px solid ${errorColor}`,
		},
	},
	ddInputHeader: {
		height: 41,
		width: '100%',
		padding: [[0, 15]],
		outline: 'none',
		border: 'none',
		borderRadius: 4,
		backgroundColor: colorsNew.dark2,
		'&::placeholder': {
			overflow: 'visible',
			color: 'white',
			opacity: 0.42,
			verticalAlign: 'middle',
			fontSize: 16,
		},
	},
	ddInputHeaderLocked: {
		cursor: 'not-allowed',
	},
	ddInputHeaderError: {
		'&::placeholder': {
			color: errorColor,
		},
	},
	ddHeader: {
		display: 'inline-flex',
		height: '100%',
	},
	arrowUp: {
		transform: 'rotate(270deg) !important',
	},
	arrowDown: {
		width: 15,
		position: 'absolute',
		top: 12,
		right: 8,
		transform: 'rotate(90deg)',
		transitionDuration: '0.5s',
		cursor: 'pointer',
	},
	ddList: {
		position: 'absolute',
		zIndex: 99,
		padding: 0,
		bottom: -2,
		transform: 'translateY(100%)',
		margin: 0,
		overflow: 'auto',
		maxHeight: 175,
		width: '100%',
	},
	ddListItem: {
		boxSizing: 'border-box',
		width: '100%',
		overflow: 'hidden',
		minHeight: 35,
		display: 'flex',
		padding: [['.2em', '.4em']],
		alignItems: 'center',
		wordBreak: 'break-all',
		backgroundColor: colorsNew.dark1,
		listStyle: 'none',
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: colorsNew.light5,
		},
	},
	chip: {
		position: 'absolute',
		margin: 3,
		zIndex: 98,
		top: '50%',
		transform: 'translateY(-60%)',
		left: 3,
		height: 30,
		backgroundColor: colorsNew.dark2,
	},
	chipDelete: {
		transform: 'translateY(1px)',
	},
	multiChip: {
		position: 'relative',
		margin: [[5, 5]],
		backgroundColor: 'transparent',
	},
	loadingBlock: {
		bottom: -2,
		transform: 'translateY(100%)',
		width: '100%',
		height: 29,
		boxShadow: '0 0 26px 0 rgba(0, 0, 0, 0.16)',
		position: 'absolute',
		zIndex: 1,
		backgroundColor: colorsNew.dark1,
		marginTop: 5,
	},
	spinnerBox: {
		display: 'flex',
		alignItems: 'center',
		height: '100%',
		width: '100%',
		justifyContent: 'center',
	},
	pulseContainer: {
		width: 120,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	pulseBubble: {
		width: 5,
		height: 5,
		borderRadius: '50%',
		backgroundColor: 'white',
	},
	error: errorStyle,
	pulseBubble1: {
		animation: 'pulse .4s ease 0s infinite alternate',
	},
	pulseBubble2: {
		animation: 'pulse .4s ease .2s infinite alternate',
	},
	pulseBubble4: {
		animation: 'pulse .4s ease .4s infinite alternate',
	},
	icon: {
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
		right: 10,
		cursor: 'pointer',
	},
	'@keyframes pulse': {
		from: {
			opacity: 1,
			transform: 'scale(1)',
		},
		to: {
			opacity: '.25',
			transform: 'scale(.75)',
		},
	},
	insideField: {
		position: 'absolute',
		right: -5,
		top: 0,
		width: 180,
		display: 'flex',
	},
	iconWrapper: {
		position: 'absolute',
		backgroundColor: '#5276A0',
		right: 0,
		top: 0,
		width: 50,
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
}
